const sliderCategoryMenu = {

    init() {

        let swiper_category;
        const swiper_category_exist = document.querySelector('.swiper-category-plat');
            swiper_category = new Swiper('.swiper-category-plat', {
                loop: false,
                slidesPerView: 3,
                centeredSlides: false,
                spaceBetween: 10,
                
                navigation: {
                    nextEl: ".swiper-category-next",
                    prevEl: ".swiper-category-prev",
                },
                pagination: {
                    el: '.swiper-pagination-category',
                },
                breakpoints: {
                    420: {
                        slidesPerView: 3,
                        spaceBetween: 10,
                    },
                    768: {
                        slidesPerView: 4,
                        spaceBetween: 15,
                    },
                    1024: {
                        slidesPerView: 5,
                        spaceBetween:20,
                    },
                }

            });
            
      
        // const enableSwiper = function() {
            
        // };

        // const breakpointChecker = function() {
        //     if ( breakpoint.matches === true ) {
        //         if ( swiper_category !== undefined ) swiper_category.destroy( true, true );
        //         return;
        //     } 
        //     else if ( breakpoint.matches === false ) {
        //         return enableSwiper();
    
        //     }
        // };
        // if(swiper_category_exist) {
        //     breakpoint.onchange =  breakpointChecker;
        //     breakpointChecker();
        // }
    }
}

export default sliderCategoryMenu;